import { useCallback, useMemo } from 'react';

import { useCustomSearchParams } from '@selfserve/react-hooks';
import { sortingOrder } from '@selfserve/react-utils';

interface IReturn {
  sortValue: string;
  sortType: string;
  handleSortChange: (value: string) => () => void;
}

export const useSortByUrl = (): IReturn => {
  const [query, setQuery] = useCustomSearchParams();
  const sort = useMemo(() => (query['sort'] as string), [query['sort']]);
  const [sortValue, sortType] = useMemo(
    () => sort ? decodeURIComponent(sort).split('-') : ['', ''],
    [sort]
  );

  const handleSortChange = useCallback(
    (value: string) => () => {
      const newSortType =
        sortValue !== value || sortType === sortingOrder.DESC
          ? sortingOrder.ASC
          : sortingOrder.DESC;
      setQuery((prevQuery) => ({
        ...prevQuery,
        sort: [encodeURIComponent(value), newSortType].join('-'),
      }));
    },
    [setQuery]
  );

  return {
    sortType,
    sortValue,
    handleSortChange,
  };
};
